import React from 'react'
import { Badge } from 'reactstrap'
import { normalizeStatus, statusLabel } from './cashMahanUtils'

function badgeColor(status) {
  switch (status) {
    case 'completed':
    case 'settled':
    case 'paid':
    case 'success':
    case 'successful':
      return 'success'
    case 'pending':
    case 'pending_review':
    case 'pending_settlement':
    case 'unsettled':
      return 'warning'
    case 'approved':
    case 'captured':
    case 'processing':
      return 'primary'
    case 'rejected':
    case 'failed':
    case 'cancelled':
    case 'canceled':
    case 'refunded':
      return 'danger'
    default:
      return 'secondary'
  }
}

export default function CashMahanStatusBadge(props) {
  const status = normalizeStatus(props.item || props.status)
  return (
    <Badge className='shadow' color={badgeColor(status)} style={{ textTransform: 'capitalize' }}>
      {statusLabel(props.item || props.status)}
    </Badge>
  )
}
